import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { getURLs } from '../../helpers/navigation';

const Pagination = ({ lastPage = 0, pageNumber = 0, url = null }) => {
  const currentPage = Number.parseInt(pageNumber, 10) || 0;
  const { cleanUrl, nextPage, nextUrl, previousPage, previousUrl } = getURLs({
    currentPage,
    lastPage,
    url,
  });

  return (
    <>
      <div className="server-pagination-container">
        {currentPage !== 0 && (
          <>
            <a
              aria-label={`Go to previous page, page ${previousPage}`}
              className="server-pagination-item server-pagination-previous server-pagination-button server-pagination-separator"
              href={`${previousUrl}`}
            >
              <FontAwesomeIcon icon={faChevronLeft} />
              <span> Previous</span>
            </a>
            <a
              aria-label={`Go to first page, page 1 `}
              className="server-pagination-item server-pagination-button"
              href={`${cleanUrl}`}
            >
              1
            </a>
            <span className="server-pagination-item server-pagination-ellipsis">
              ...
            </span>
          </>
        )}
        <span
          aria-label="Current page"
          className="server-pagination-item server-pagination-selected"
        >
          {currentPage === 0 ? 1 : currentPage}
        </span>
        {currentPage !== lastPage && (
          <>
            <span className="server-pagination-item server-pagination-ellipsis">
              ...
            </span>
            <a
              aria-label={`Go to last page, page ${lastPage} `}
              className="server-pagination-item server-pagination-button"
              href={`${cleanUrl}?page=${lastPage}`}
            >
              {lastPage}
            </a>
            <a
              aria-label={`Go to next page, page ${nextPage} `}
              className="server-pagination-item server-pagination-next server-pagination-button server-pagination-separator"
              href={`${nextUrl}`}
            >
              <span>Next </span>
              <FontAwesomeIcon icon={faChevronRight} />
            </a>
          </>
        )}
      </div>
      <style jsx>{`
        .server-pagination-container {
          padding: 30px 0;
          text-align: center;
        }

        .server-pagination-strip {
          display: inline-block;
          white-space: nowrap;
          border-radius: 8px;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        }

        .server-pagination-item {
          display: inline-block;
          color: #6f7373;
          line-height: 46px;
          padding: 0 12px;
          border-top: 1px solid #d5d9d9;
          border-bottom: 1px solid #d5d9d9;
          min-width: 24px;
          height: 46px;
          position: relative;
          box-sizing: content-box;
        }

        .server-pagination-button,
        .server-pagination-button:active,
        .server-pagination-button:focus,
        .server-pagination-button:hover,
        .server-pagination-button:link,
        .server-pagination-button:visited {
          color: #0f1111;
          text-decoration: none;
        }

        .server-pagination-button:focus {
          outline: 0;
        }

        .server-pagination-button:focus,
        .server-pagination-button:hover {
          background: #f5f6f6;
        }

        .server-pagination-button:active {
          background: #f7f8f8;
        }

        .server-pagination-next,
        .server-pagination-previous {
          min-width: 70px;
        }

        .server-pagination-previous {
          border-left: 1px solid #d5d9d9;
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
        }

        .server-pagination-next {
          border-right: 1px solid #d5d9d9;
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
        }

        .server-pagination-separator {
          padding: 0 13px;
          min-width: 69px;
        }

        .server-pagination-ellipsis {
          color: #6f7373;
          min-width: 10px;
        }

        .server-pagination-selected {
          color: #0f1111;
          font-weight: 700;
          border: 1px solid #0f1111;
          padding: 0 11px;
        }

        .server-pagination-disabled {
          color: #6f7373;
        }

        .server-pagination-item + .server-pagination-separator:before,
        .server-pagination-separator + .server-pagination-item:before {
          content: '';
          width: 1px;
          height: 32px;
          background: #d5d9d9;
          position: absolute;
          left: 0;
          top: 7px;
        }

        .server-pagination-item + .server-pagination-separator:before {
          left: 0;
        }

        .server-pagination-button.server-pagination-separator:focus
          + .server-pagination-item:before,
        .server-pagination-button.server-pagination-separator:hover
          + .server-pagination-item:before,
        .server-pagination-button:focus + .server-pagination-separator:before,
        .server-pagination-button:hover + .server-pagination-separator:before,
        .server-pagination-item
          + .server-pagination-button.server-pagination-separator:focus:before,
        .server-pagination-item
          + .server-pagination-button.server-pagination-separator:hover:before,
        .server-pagination-separator + .server-pagination-button:focus:before,
        .server-pagination-separator + .server-pagination-button:hover:before {
          background: #f0f1f1;
          height: 46px;
          top: 0;
        }
      `}</style>
    </>
  );
};
export default Pagination;

Pagination.propTypes = {
  lastPage: PropTypes.number,
  pageNumber: PropTypes.string,
  url: PropTypes.string,
};
